import type { ITableStructure } from "../../../../models/storeModels/ITableConfiguration";
import { tableEnums } from "../../../../widgets/table/tableFeatures/tableEnums";
import { baseAPI } from "../baseApi";

type TableQueryParams = {
    top?: number;
    skip?: number;
    order?: string;
    pages?: boolean;
    filterStringArray?: string[];
    filterString?: string;
}

type FetchTableValueArgs = {
    tableValueUrl: string;
} & TableQueryParams;

export const buildTableQueryParams = ({ top, skip, order, pages, filterStringArray, filterString }: TableQueryParams) => {
    const paramsParts = [];
    if (top != null) paramsParts.push(`$top=${top}`);
    if (skip != null) paramsParts.push(`$skip=${skip}`);
    if (order) paramsParts.push(`$orderby=${order}`);
    if (pages) paramsParts.push(`$inlinecount=allpages`);
    if (filterStringArray?.length) paramsParts.push(`$filter=(${filterStringArray.join(' and ')})`);
    if (filterString?.length) paramsParts.push(`$filter=(${filterString})`);

    return paramsParts.join('&');
};

export const tablesApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение структуры табличных данных для типов объектов
        fetchTablesStructure: builder.query<ITableStructure[], any>({
            query: () => ({
                url: `structure?AuthToken=X&type=tables`
            })
        }),
        // запрос на получение данных таблицы
        fetchTableValue: builder.query<any, FetchTableValueArgs>({
            query: ({ tableValueUrl, ...queryParams }) => {
                const queryString = buildTableQueryParams(queryParams);
                return {
                    url: `${tableValueUrl}?${queryString}`,
                };
            },
            // преобразование данных в случае нахождения в определенном списке значений
            transformResponse: (response: any) => {
                response && response.value.map((item: any) => {
                    Object.keys(tableEnums).map((key: string, index) => {
                        if (item.hasOwnProperty(key) && item[key] !== null) {
                            if (item[key] === false) {
                                item[key] = 0
                            } else if (item[key] === true) {
                                item[key] = 1
                            }
                        }
                    })
                })
                return response
            }
        }),
    })
})

export const {
    useFetchTablesStructureQuery,
    useFetchTableValueQuery,
    useLazyFetchTableValueQuery
} = tablesApiSlice